import { Component } from '@angular/core';
import { BuyerSummary, BuyersService } from 'src/app/core/buyers.service';
import { ErrorService } from 'src/app/core/error.service';

@Component({
  selector: 'app-buyers-summary',
  templateUrl: './buyers-summary.component.html',
  styleUrls: ['./buyers-summary.component.scss'],
})
export class BuyersSummaryComponent {
  is_summary_request_running: boolean = true;
  summary?: BuyerSummary;

  constructor(private error_service: ErrorService, private buyers_service: BuyersService) {}

  ngOnInit(): void {
    this.readSummary();
  }

  onRefresh(): void {
    this.readSummary();
  }

  readSummary(): void {
    this.is_summary_request_running = true;
    this.buyers_service.readSummary().subscribe({
      next: response => {
        this.summary = response.data;
        this.is_summary_request_running = false;
      },
      error: error => {
        this.error_service.processGenericApiError(error);
        this.is_summary_request_running = false;
      },
    });
  }
}
